import { useParams } from "react-router-dom";
import { useAppNavigation } from "@/hooks/useAppNavigation";
import { useAuthContext } from "@/hooks/AuthProvider";
import { ComponentType } from "react";

// Wrapper generique qui injecte onNavigate, onBack, et les params URL
// dans les pages qui les attendent en props (compatibilite maquette)
export function withNavigation<P extends Record<string, unknown>>(
  Component: ComponentType<P>,
  extraProps?: Partial<P> | ((params: Record<string, string | undefined>, role: string | null) => Partial<P>)
) {
  return function WrappedPage() {
    const { onNavigate, onBack } = useAppNavigation();
    const params = useParams();
    const { role } = useAuthContext();

    const resolved = typeof extraProps === "function"
      ? extraProps(params, role)
      : extraProps || {};

    const props = {
      onNavigate,
      onBack,
      ...resolved,
    } as unknown as P;

    return <Component {...props} />;
  };
}
